export default __webpack_public_path__ + "static/media/playbook.21bee0ba.png";